// src/components/AppFooter/AppFooter.js
import React from "react";
import PropTypes from "prop-types";
import AutoReconnectToggle from "../../AutoReconnectToggle";
import ModalToggle from "../../ModalToggle";
import ThemeToggle from "../../ThemeToggle";
import "./AppFooter.css";

/**
 * AppFooter - Main application footer component
 *
 * Displays WebSocket connection status and user preference toggles.
 * Hidden in simplified device view mode.
 */
const AppFooter = ({
  connectionStatus,
  isAutoReconnectEnabled,
  isModalEnabled,
  theme,
  deviceViewMode,
  onReconnect,
  onToggleAutoReconnect,
  onToggleModal,
  onToggleTheme,
  onResetLayout,
}) => {
  return (
    <footer
      className={`footer-status-bar ${
        deviceViewMode === "simplified" ? "hidden" : ""
      }`}
    >
      <div className="connection-status-container">
        <p>
          WebSocket Status:{" "}
          <span className={connectionStatus.toLowerCase().replace(/\s+/g, "-")}>
            {connectionStatus}
          </span>
        </p>
        {!isAutoReconnectEnabled &&
          (connectionStatus === "Disconnected" ||
            connectionStatus === "Connection Error") && (
            <button className="reconnect-button" onClick={onReconnect}>
              Reconnect
            </button>
          )}
      </div>
      <div className="footer-toggles-container">
        <AutoReconnectToggle
          isEnabled={isAutoReconnectEnabled}
          onToggle={onToggleAutoReconnect}
          disabled={true}
          tooltip="This setting is enabled for all users"
        />
        <ModalToggle
          isEnabled={isModalEnabled}
          onToggle={onToggleModal}
          disabled={isAutoReconnectEnabled}
          label="Show Websocket Reconnect Warning"
        />
        <ThemeToggle theme={theme} onToggle={onToggleTheme} />
        {onResetLayout && (
          <button
            className="reset-layout-button"
            onClick={onResetLayout}
            title="Reset panel order and expand all panels"
          >
            ↺ Reset Layout
          </button>
        )}
      </div>
      <div className="footer-links-container">
        <a
          href="/privacy-policy.html"
          target="_blank"
          rel="noopener noreferrer"
          className="privacy-policy-link"
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
};

AppFooter.propTypes = {
  connectionStatus: PropTypes.string.isRequired,
  isAutoReconnectEnabled: PropTypes.bool.isRequired,
  isModalEnabled: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
  deviceViewMode: PropTypes.string.isRequired,
  onReconnect: PropTypes.func.isRequired,
  onToggleAutoReconnect: PropTypes.func.isRequired,
  onToggleModal: PropTypes.func.isRequired,
  onToggleTheme: PropTypes.func.isRequired,
  onResetLayout: PropTypes.func,
};

export default AppFooter;
